// src/utils/logger.ts
var errorMsgs = /* @__PURE__ */ new Set();
var logger = {
  errorOnce(msg) {
    if (!errorMsgs.has(msg)) {
      errorMsgs.add(msg);
      console.error(msg);
    }
  }
};

export { logger };
